import React, { useState, useEffect } from "react";
import useWindowSize from "utils/useWindowSize";
import { getNewsList } from "context/actions/news";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Container,
  Paper,
  Typography,
} from "@mui/material";
import Image from "next/image";

const Slider = ({ linkData, interval = 3000 }) => {
  const { sizes } = useWindowSize();

  return (
    // <Box>
      <Box className=" w-full h-[200px]">
        <Image
          src="/cover.png"
          alt="Mandal Cargo"
          width={100}
          height={100}
          layout="responsive"
          className=" mt-[60px]"
        />
      </Box>
    // </Box>
  );
};

export default Slider;
